import React from 'react';
import { Chip, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Chip de estado de un empleado IA de una cuenta de cliente.
// provisioning/pending llevan spinner: la provisión (install→build→deploy) corre
// en background en el backend y puede tardar minutos.
interface EmployeeStatusChipProps {
  status: string;
  size?: 'small' | 'medium';
}

const EmployeeStatusChip: React.FC<EmployeeStatusChipProps> = ({ status, size = 'small' }) => {
  const { t } = useTranslation();

  const config: Record<string, { label: string; color: 'default' | 'info' | 'success' | 'error' | 'warning' }> = {
    pending: { label: t('clientAccounts.employeeStatus.pending', 'Pendiente'), color: 'default' },
    provisioning: { label: t('clientAccounts.employeeStatus.provisioning', 'Desplegando'), color: 'info' },
    active: { label: t('clientAccounts.employeeStatus.active', 'Activo'), color: 'success' },
    failed: { label: t('clientAccounts.employeeStatus.failed', 'Fallido'), color: 'error' },
    suspended: { label: t('clientAccounts.employeeStatus.suspended', 'Suspendido'), color: 'warning' },
    removed: { label: t('clientAccounts.employeeStatus.removed', 'Eliminado'), color: 'default' }
  };

  const entry = config[status] || { label: status, color: 'default' as const };
  const inProgress = status === 'provisioning' || status === 'pending';

  return (
    <Chip
      label={entry.label}
      color={entry.color}
      size={size}
      icon={inProgress ? <CircularProgress size={14} color="inherit" /> : undefined}
      sx={{ fontWeight: 600 }}
    />
  );
};

export default EmployeeStatusChip;
